export const GET_UPLOAD_LINK = "Landing/GET_UPLOAD_LINK";
export const SUBMIT_FILE = "Landing/SUBMIT_FILE";
export const DELETE_FILE = "Landing/DELETE_FILE";
export const GET_ALL_FILES = "Landing/GET_ALL_FILES";
export const SET_ALL_FILES = "Landing/SET_ALL_FILES";
